module.exports = __webpack_public_path__ + "images/liinilaevad/apple-icon-144x144.png";